import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { LectionaryItemSearchModel } from '../components/lectionary-item-search/lectionary-item-search.component';

@Injectable()
export class LectionaryItemService {

  constructor(private apiSvc: ApiService) { }

  public loadEntities(model: LectionaryItemSearchModel): Promise<LectionaryItemSummary[]> {

    const p = new Promise<LectionaryItemSummary[]>((resolve, reject) => {

      this.apiSvc.post("api/lectionaryitem/GetSummaryList", model).subscribe(
        (data: LectionaryItemSummary[]) => {
          console.log("loadItemNames", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

  public getItem(itemId: number): Promise<LectionaryItem> {

    const p = new Promise<LectionaryItem>((resolve, reject) => {

      this.apiSvc.get("api/lectionaryitem/GetItem/" + itemId, null).subscribe(
        (data: LectionaryItem) => {
          console.log("lectionaryitem/GetItem", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

  public delete(id: number): Promise<void> {

    const p = new Promise<void>((resolve, reject) => {
  
      var payload = new LectionaryItem();
      payload.Id = id;
  
      this.apiSvc.post("api/lectionaryitem/delete/", payload).subscribe(
        (data: string) => {
          console.log("lectionaryitem/delete");
          resolve();
        },
        (err) => {
          console.log("error", err);
          reject(err);
        }
      );
  
    });
  
    return p;
  }

}


export class LectionaryItem {
  Id: number;
  IsActive: boolean;
  LectionarySourcePageNumber: string;
  HTML: string;
  ReligionBranch: any;
  LectionaryItemType: any;
  LectionarySource: any;
  LectionaryItemName: any;
  LanguageStyle: any;
  ApprovedDate: Date;
  ProofedByName: string;
  ProofedByUserId: number;
}

export class LectionaryItemSummary {
  Id: number;
  IsActive: boolean;
  ApprovedByUserId: number;
  ItemName: string;
  Source: string;
  PageNumber: string;
  LectionaryItemType: string;
  LanguageStyle: string;
  IsProofed: boolean;
}
